<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Filter
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="mb-3">
                        <label class="control-label">Assigned User</label>
                        <multiselect :show-labels="false" :options="users" v-model="usersSelected" label="name" track-by="id" placeholder="Select User" :multiple="true"></multiselect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Multiselect from 'vue-multiselect'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            Multiselect
        },

        data: function () {
            return {
                loaded: false
            }
        },

        computed: {

            ...mapState('users', {
                users: 'users'
            }),

            ...mapState('yodizproject/tasks', {
                filters: 'filters'
            }),

            usersSelected: {
                get () {
                    return this.filters.users
                },

                set (value) {
                    this.setStateProperty({ property: 'filters.users', value: value })
                }
            }
        },

        methods: {
            ...mapActions('yodizproject/tasks', {
                setFilters: 'setFilters',
                setStateProperty: 'setStateProperty'
            })
        }
    }
</script>